import React from 'react';
import styled from 'styled-components';

interface TitleProps {
    children: React.ReactNode;
    color?: string;
}

const StyledTitle = styled.div<{ $color?: string }>`
    font-size: ${({ theme }) => theme.fontSizes.title};
    font-weight: ${({ theme }) => theme.fontWeights.semibold};
    text-transform: uppercase;
    letter-spacing: 2px;
    color: ${({ $color, theme }) => $color || theme.colors.primary};
    margin-bottom: ${({ theme }) => theme.spacing.lg};
`;

export const Title: React.FC<TitleProps> = ({ children, color }) => {
    return <StyledTitle $color={color}>{children}</StyledTitle>;
};
